import React, { useEffect, useState } from "react";
import useLoader from "../../../hooks/useLoader";
import { Paper } from "@material-ui/core";
import { PrimaryCTAButton } from "../../common/Buttons";
import { useSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";
import { useLocation } from "@reach/router";
import EsignInService from "../../../services/EsignInService";
import {
  DrawerContainer,
  Container,
  Heading,
  HalfWidth,
  HeadingContainer,
  Form,
  Description,
} from "./Styles";
import { metaData } from "./comppnent/Meta";
import moment from "moment";
import { downloadWithDifferenFileName } from "../../../helpers/functions";

const PreSignIn = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const history = useLocation();
  const queryParams = new URLSearchParams(history.search);
  const arbitratorId = queryParams.get("arbitratorId");
  const [valid, setValid] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        localStorage.removeItem("auth_token");
        const response = await EsignInService.getEsignData(arbitratorId);
        const expiryTime =
          new Date(response?.record?.updated_at).getTime() +
          5 * 24 * 60 * 60 * 1000;
        if (Date.now() > expiryTime) {
          setValid(true);
        }
        if (response.record) {
          const s3Url = response.record.fileBase64;
          const res = await fetch(s3Url);
          const blob = await res.blob();
          const base64String = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
          setData({
            ...response.record,
            fileBase64: base64String,
          });
        }
      } catch (error) {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      }
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onFormSubmit = async () => {
    try {
      setLoader({ state: true, message: "loading emudhra..." });
      const requestPayload = {
        ...metaData,
        ReferenceNumber: uuidv4(),
        Name: data?.arbitratorName,
        File: data?.fileBase64,
        SignaturePosition: data?.SignaturePosition,
        CustomizeCoordinates: data?.CustomizeCoordinates,
        SignatureMode: data?.SignatureMode || "12,1,2,3",
      };
      const payload = {
        update_at: data?.updated_at,
        esignerLogs: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      if (valid) {
        enqueueSnackbar("Link is expired, please contact to renew the link", {
          variant: "error",
        });
      } else {
        if (data?.eSignedFile?.length) {
          enqueueSnackbar("You have already signed this given link", {
            variant: "error",
          });
        } else {
          const response = await EsignInService.emudhraCreate(requestPayload);
          await EsignInService.updateEsignedFile(arbitratorId, payload);
          localStorage.setItem("arbitratorId", arbitratorId);
          const keysToInclude = ["Parameter1", "Parameter2", "Parameter3"];
          const filtered = {};
          keysToInclude.forEach((key) => {
            if (response.data[key] !== undefined) {
              filtered[key] = response.data[key];
            }
          });
          setFormData(filtered);
          setTimeout(() => {
            const form = document.getElementById("dynamicForm");
            if (form) {
              form.submit();
            }
          }, 0);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader({ state: false });
    }
  };

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      padding: "20px",
      transition: "background-color 0.3s ease",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "60px 50px",
      maxWidth: "600px",
      width: "100%",
      textAlign: "center",
      transition: "all 0.3s ease",
      transform: isHovered ? "translateY(-2px)" : "translateY(0)",
      boxShadow: isHovered
        ? "0 8px 12px rgba(0, 0, 0, 0.15), 0 20px 40px rgba(0, 0, 0, 0.12)"
        : "0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 20px rgba(0, 0, 0, 0.08)",
    },
    title: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#1a3a52",
      fontFamily: "openSans-SemiBold, sans-serif",
      marginBottom: "20px",
      letterSpacing: "-0.5px",
    },
    description: {
      fontSize: "16px",
      fontFamily: "openSans-SemiBold, sans-serif",
      color: "#293461",
      marginBottom: "40px",
      lineHeight: "1.6",
      fontWeight: "500",
    },
    button: {
      backgroundColor: "#0b7285",
      color: "white",
      border: "none",
      padding: "14px 40px",
      fontSize: "16px",
      fontWeight: "600",
      borderRadius: "6px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      width: "100%",
      maxWidth: "200px",
      outline: "none",
      boxShadow: "0 2px 4px rgba(11, 114, 133, 0.2)",
      letterSpacing: "0.3px",
    },
    buttonHover: {
      backgroundColor: "#055a6f",
      boxShadow: "0 6px 12px rgba(11, 114, 133, 0.3)",
      transform: "scale(1.02)",
    },
    successMessage: {
      position: "fixed",
      top: "30px",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#27ae60",
      color: "white",
      padding: "16px 30px",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "600",
      boxShadow: "0 4px 12px rgba(39, 174, 96, 0.3)",
      animation: "slideIn 0.3s ease-out, slideOut 0.3s ease-in 2.7s",
      zIndex: 1000,
    },
    features: {
      display: "flex",
      justifyContent: "center",
      gap: "30px",
      marginTop: "50px",
      paddingTop: "40px",
      borderTop: "1px solid #eee",
    },
    feature: {
      flex: 1,
      fontSize: "13px",
      color: "#666",
      fontWeight: "500",
    },
    featureIcon: {
      fontSize: "24px",
      marginBottom: "10px",
      display: "block",
    },
  };

  return data?.eSignedFile?.length ? (
    <>
      <div style={styles.container} onMouseLeave={() => setIsHovered(false)}>
        <div
          style={styles.card}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <h1 style={styles.title}>Signer Gateway</h1>
          <p style={styles.description}>
            You have already completed the sign-in. Please click to download the
            sign-in document.
          </p>
          <PrimaryCTAButton
            style={{ padding: "10px 10px" }}
            onClick={() =>
              downloadWithDifferenFileName(
                data?.eSignedFile,
                `${moment().format("YYYY-MM-DD_HH-mm-ss")}_E-sign-In`
              )
            }
          >
            Download
          </PrimaryCTAButton>

          <div style={styles.features}>
            <div style={styles.feature}>
              <span style={styles.featureIcon}>{"🔒"}</span>
              Secure Access
            </div>
            <div style={styles.feature}>
              <span style={styles.featureIcon}>✓</span>
              Verify Docs
            </div>
            <div style={styles.feature}>
              <span style={styles.featureIcon}>{"✍️"}</span>
              Digital Sign
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <DrawerContainer>
      <Container>
        <Paper elevation={3} style={{ padding: "16px", borderRadius: 10 }}>
          <HeadingContainer>
            <Heading>Signer Gateway</Heading>
          </HeadingContainer>
          <div className="status-list">
            <>
              <Description>
                A secure entry point for users to access, verify, and sign
                documents digitally
              </Description>
              <HeadingContainer>
                <HalfWidth>
                  <PrimaryCTAButton
                    style={{ padding: "10px 10px" }}
                    onClick={onFormSubmit}
                  >
                    Proceed to Sign
                  </PrimaryCTAButton>
                </HalfWidth>
              </HeadingContainer>
              <Form
                id="dynamicForm"
                method="post"
                action="https://gateway-core.emsigner.com/Secure/index"
                // action="https://emgateway.emsigner.com/eMsecure/V3_0/Index"
                // action="https://demosignergateway.emsigner.com/eMsecure/V3_0/Index"
              >
                {Object.entries(formData).map(([key, value]) => (
                  <input key={key} type="hidden" name={key} value={value} />
                ))}
              </Form>
            </>
          </div>
        </Paper>
      </Container>
    </DrawerContainer>
  );
};

export default PreSignIn;
